// extracted by mini-css-extract-plugin
export default {"type_selector":"TypeSelector_type_selector__GWoY7","type_selector__label":"TypeSelector_type_selector__label__gA3f+"};